import { User } from 'types';

export const getUserFullName = (
  user: User | Pick<User, 'Name' | 'last_name'>,
): string => {
  if (user.Name === null && user.last_name === null) {
    user.Name = '';
    user.last_name = '';
  }

  return `${user.Name} ${user.last_name}`;
};

export const getUserRole = '';
